export default __webpack_public_path__ + "static/media/logo-empresa.f2020bc6.png";